export const ANIMALS:{
  [index:string]:string
} = {
  fish: '🐠',
  shark: '🦈',
  monkey: '🐒',
  gorilla: '🦍',
  dog: '🐕',
  poodle: '🐩',
  wolf: '🐺',
  fox: '🦊',
  raccoon: '🦝',
  cat: '🐈',
  lion: '🦁',
  tiger: '🐅',
  leopard: '🐆',
  horse: '🐎',
  unicorn: '🦄',
  zebra: '🦓',
  deer: '🦌',
  ox: '🐂',
  'water buffalo': '🐃',
  cow: '🐄',
  pig: '🐖',
  boar: '🐗',
  ram: '🐏',
  sheep: '🐑',
  goat: '🐐',
  camel: '🐪',
  llama: '🦙',
  giraffe: '🦒',
  elephant: '🐘',
  rhinoceros: '🦏',
  hippopotamus: '🦛',
  mouse: '🐁',
  rat: '🐀',
  rabbit: '🐇',
  chipmunk: '🐿',
  hedgehog: '🦔',
  bat: '🦇',
  bear: '🐻',
  koala: '🐨',
  panda: '🐼',
  kangaroo: '🦘',
  badger: '🦡',
  turkey: '🦃',
  chicken: '🐔',
  rooster: '🐓',
  'baby chick': '🐤',
  bird: '🐦',
  penguin: '🐧',
  eagle: '🦅',
  duck: '🦆',
  swan: '🦢',
  owl: '🦉',
  peacock: '🦚',
  parrot: '🦜',
  frog: '🐸',
  crocodile: '🐊',
  turtle: '🐢',
  lizard: '🦎',
  snake: '🐍',
  dragon: '🐉',
  sauropod: '🦕',
  't-rex': '🦖',
  whale: '🐳',
  dolphin: '🐬',
  tuna: '🐟',
  blowfish: '🐡',
  octopus: '🐙',
  'spiral shell': '🐚',
  snail: '🐌',
  butterfly: '🦋',
  bug: '🐛',
  ant: '🐜',
  honeybee: '🐝',
  'lady beetle': '🐞',
  cricket: '🦗',
  spider: '🕷',
  'spider web': '🕸',
  scorpion: '🦂',
  mosquito: '🦟',
  microbe: '🦠',
  crab: '🦀',
  lobster: '🦞',
  shrimp: '🦐',
  squid: '🦑'
}

export const PLANTS:{
  [index:string]:string
} = {
  bouquet: '💐',
  'cherry blossom': '🌸',
  'white flower': '💮',
  rosette: '🏵',
  rose: '🌹',
  'wilted flower': '🥀',
  hibiscus: '🌺',
  sunflower: '🌻',
  blossom: '🌼',
  tulip: '🌷',
  seedling: '🌱',
  pine: '🌲',
  tree: '🌳',
  'palm tree': '🌴',
  cactus: '🌵',
  'sheaf of rice': '🌾',
  herb: '🌿',
  'four leaf clover': '🍀',
  mushroom: '🍄',
  chestnut: '🌰'
}